import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
//outsource
import { Row, Col, Layout, Modal, Button, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  detailBranchSelector,
  detailSelector,
} from "../../../store/branch/branch.selector";
import { allSelector, userListSelector } from "../../../store/job/job.selector";
import { getBranchByShopId } from "../../../store/branch/branch.action";
import {
  snapGroup,
  unSnapGroup,
} from "../../../store/group_service/group.action";
import {
  snapAllServices,
  unSnapAll,
} from "../../../store/service/service.action";
import IncomeStaffRadio from "./component/income_staff_radio";
import IncomeStaffCompleted from "./component/income_staff_completed";
import IncomeStaffWaiting from "./component/income_staff_waiting";
import { staffListSelector } from "../../../store/staff/staff.selector";
import { ignoreSelectJobSelector } from "../../../store/var/var.selector";
//components

const DialogIncomeStaffAdd = ({
  open,
  setOpen,
  setOpenInput,
  setRecord,
  userId,
  staffList,
}) => {
  // -------------------------- VAR --------------------------
  const params = useParams();
  const shopId = params?.shopId;
  // -------------------------- STATE --------------------------
  const [tab, setTab] = useState("waiting");

  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const branch = useSelector(detailBranchSelector);
  const jobs = useSelector(allSelector);
  const userList = useSelector(staffListSelector);
  const ignoreJob = useSelector(ignoreSelectJobSelector);

  // -------------------------- FUNCTION --------------------------
  const handleCancel = () => {
    setOpen(false);
  };
  const handleIgnore = () => {
    setOpenInput(true);
    setOpen(false);
  };

  // -------------------------- EFFECT --------------------------
  //Get Detail Branch
  useEffect(() => {
    if (shopId) {
      dispatch(getBranchByShopId({ shopId }));
    }
  }, [dispatch, shopId]);

  //Get services and group + staff info
  useEffect(() => {
    if (branch) {
      dispatch(snapGroup({ branch: branch?.id }));
      dispatch(snapAllServices({ branch: branch?.id }));
    }

    return () => {
      dispatch(unSnapGroup());
      dispatch(unSnapAll());
    };
  }, [dispatch, branch]);

  // ignore job
  useEffect(() => {
    // console.log({ open });
    if (open && ignoreJob) {
      setOpenInput(ignoreJob);
      setOpen(false);
    }
  }, [open, ignoreJob]);

  // -------------------------- RENDER --------------------------

  const renderJobList = () => {
    // console.log(jobs);
    return (
      <Row gutter={[20, 20]}>
        <IncomeStaffRadio tab={tab} setTab={setTab} />
        {tab === "waiting" ? (
          <IncomeStaffWaiting
            jobs={jobs}
            loading={loading}
            userList={userList}
            setOpenInput={setOpenInput}
            setRecord={setRecord}
            userId={userId}
          />
        ) : (
          <IncomeStaffCompleted
            jobs={jobs}
            loading={loading}
            userList={userList}
          />
        )}
        {renderButtonGroup()}
      </Row>
    );
  };

  const renderButtonGroup = () => {
    return (
      <Col span={24}>
        <Row gutter={[10, 10]} justify="center">
          <Col span={8}>
            <Button type="default" size="large" block onClick={handleCancel}>
              Done
            </Button>
          </Col>
          {/* <Col span={12}>
            <Button type="primary" size="large" block onClick={handleIgnore}>
              Ignore Job
            </Button>
          </Col> */}
        </Row>
      </Col>
    );
  };

  // -------------------------- MAIN --------------------------
  const currentUser = staffList?.find((user) => user?.id === userId);
  const title = `Job List for ${currentUser?.firstName} ${currentUser?.lastName} `;
  return (
    <Modal
      open={open && !ignoreJob}
      onCancel={handleCancel}
      footer={false}
      title={title}
      width={1000}
    >
      {renderJobList()}
    </Modal>
  );
};

export default DialogIncomeStaffAdd;
